import React from "react";

// Language Data
import koData from "../../../data/i18n/ko.json";
import jaData from "../../../data/i18n/ja.json";
import enData from "../../../data/i18n/en.json";

// Data
import tagsData from "../../../data/tags.json";

// Components
import Tag from "../../Common/Tag/Tag";

// SCSS
import "./AboutMeWindow.scss";

const AboutMeWindow = ({ lang, setHoveredElement }) => {
  // Language
  const langFiles = { ko: koData, ja: jaData, en: enData };
  const currentData = langFiles[lang] || koData;

  return (
    <div className="AboutMeWindow">
      <section className="WhoAmI">
        <div className="WhoAmI__Wrapper">
          <div className="WhoAmI__Handle">
            <div className="WhoAmI__Image">
              <img src={currentData.profile} alt="profile" />
            </div>
            <div className="WhoAmI__Title">
              <h3 className="WhoAmI__Title-Name">Kim Chae Yeon</h3>
              <span className="WhoAmI__Title-Id">@dkssud-dus</span>
            </div>
          </div>
          <div className="WhoAmI__Intro">
            <p className="WhoAmI__Intro-Text">{currentData.intro}</p>
          </div>
        </div>
      </section>

      <section className="Information">
        <div className="Information__Wrapper">
          <h3 className="Information__Title">Information</h3>
          <div className="Information__NoneCategory">
            <div className="Tag__Container">
              {tagsData.information.noneCategory.map((item) => (
                <Tag
                  key={item.id}
                  text={item.name}
                  iconClass={item.iconClass}
                />
              ))}
            </div>
          </div>
          <div className="Information__Connect">
            <h4>Connect</h4>
            <div className="Tag__Container">
              {tagsData.information.connect.map((item) => (
                <Tag
                  key={item.id}
                  text={item.name}
                  iconClass={item.iconClass}
                  link={item.link}
                  setHoveredElement={setHoveredElement}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="Skill">
        <div className="Skill__Wrapper">
          <h3 className="Skill__Title">Skills</h3>
          {Object.entries(tagsData.skill).map(([category, items]) => (
            <div key={category} className={`Skill__${category}`}>
              <h4>{category.charAt(0).toUpperCase() + category.slice(1)}</h4>
              <div className="Tag__Container">
                {items.map((item) => (
                  <Tag key={item.id} text={item.name} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AboutMeWindow;
